interface DownloadFileOptions {
  fileName: string;
  mimeType?: string;
}

export function downloadFile(
  data: BlobPart,
  options: DownloadFileOptions,
): void {
  const { fileName, mimeType = "text/csv" } = options;

  const blob = new Blob([data], { type: mimeType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  link.style.display = "none";
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function generateReportFileName(
  prefix: string,
  extension = "csv",
): string {
  function padWithZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = padWithZero(date.getMonth() + 1);
    const day = padWithZero(date.getDate());
    const hours = padWithZero(date.getHours());
    const minutes = padWithZero(date.getMinutes());
    const seconds = padWithZero(date.getSeconds());
    return `${year}${month}${day}_${hours}${minutes}${seconds}`;
  }

  const currentDate = new Date();
  const formattedDate = formatDate(currentDate);
  return `${prefix}_${formattedDate}.${extension}`;
}
